import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse } from '../common/types';
import type {
    GenerateReportPayload,
    ApprovalReportData,
    CreateReportBatchPayload,
    GetReportBatchPayload,
    ReportBatchItem,
    UpdateReportBatchPayload,
    GetApprovalRequestPayload,
    ApprovalRequestItem,
    ProcessApprovalPayload,
} from './types';

export const reportBatchService = {
    generateReportForApproval: async (payload: GenerateReportPayload): Promise<ApiResponse<ApprovalReportData>> => {
        const response = await apiClient.post('/Approvals/GenerateReportForApproval', payload);
        return response.data;
    },

    createReportBatch: async (payload: CreateReportBatchPayload): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/Approvals/CreateReportBatch', payload);
        return response.data;
    },

    getReportBatch: async (payload: GetReportBatchPayload): Promise<ApiResponse<PaginatedResponse<ReportBatchItem>>> => {
        const response = await apiClient.post('/Approvals/GetReportBatch', payload);
        return response.data;
    },

    getReportBatchItems: async (reportBatchId: string): Promise<ApiResponse<ApprovalReportData>> => {
        const response = await apiClient.get(`/Approvals/GetReportBatchItemsByReportBatchId?reportBatchId=${reportBatchId}`);
        return response.data;
    },

    updateReportBatchRequestItems: async (payload: UpdateReportBatchPayload): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/Approvals/UpdateReportBatchRequestItems', payload);
        return response.data;
    },

    submitBatchForApproval: async (reportBatchId: string): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/Approvals/SubmitBatchForApproval?reportBatchId=${reportBatchId}`);
        return response.data;
    },

    sendNotificationToApprovedAuthors: async (reportBatchId: string): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/Approvals/SendNotificationToApprovedAuthors?reportBatchId=${reportBatchId}`);
        return response.data;
    },

    getApprovalRequest: async (payload: GetApprovalRequestPayload): Promise<ApiResponse<PaginatedResponse<ApprovalRequestItem>>> => {
        const response = await apiClient.post('/Approvals/GetApprovalRequest', payload);
        return response.data;
    },

    processApprovalRequest: async (payload: ProcessApprovalPayload): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/Approvals/ProcessApprovalRequest', payload);
        return response.data;
    },
};
